import { LOCATION_DETAILS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/location_details_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['locationDetailsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
